<template>
  <div class="container centre-column">
    <p v-if="$route.query.redirect">
      You need to log in first.
    </p>
    <form class="form-signin">
      <h2>Please log in</h2>

      <div v-bind:class="validateEmail ? '' : 'has-error'" class="form-group">
        <label for="inputEmail" class="sr-only">Email Address</label>
        <input v-model="email" type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus></input>
      </div>

      <div v-bind:class="validatePassword ? '' : 'has-error'" class="form-group">
        <label for="inputPassword" class="sr-only">Password</label>
        <input v-model="password" type="password" id="inputPassword" class="form-control" placeholder="Password" required></input>
      </div>

      <button @click.prevent="submit" class="btn btn-lg btn-primary btn-block" type="submit">Log in</button>
    </form>

    <div class="centre-column">
      <p><router-link :to="{ name: 'forgot-password' }">forgot password</router-link></p>
      <p v-if="error" class="error">email or password is not correct</p>
    </div>
  </div>
</template>

<style scoped>
.form-signin {
  max-width: 330px;
  margin: 0 auto;
}
.centre-column {
  max-width: 330px;
  margin: 1em auto;
}
p.error {
  color: red;
}
</style>

<script>
import auth from '../auth'
import * as mutationTypes from '../store/mutation-types'

export default {
  data () {
    return {
      email: '',
      password: '',
      error: false,
      validate: false
    }
  },
  methods: {
    submit () {
      this.validate = true
      if (!this.isValid) {
        return
      }
      auth.login(this.email, this.password, (result) => {
        if (!result.authenticated) {
          this.error = true
        } else {
          this.$store.commit(mutationTypes.USER_PROFILE_LOGIN, result.auth)
          this.$store.dispatch('getUser') // should be dispatched from userProfile?
          // console.log('LOGIN REDIRECTING TO', this.$route.query.redirect)
          this.$router.replace(this.$route.query.redirect || '/')
        }
      })
    }
  },
  computed: {
    validateEmail () {
      return !this.validate || this.email !== ''
    },
    validatePassword () {
      return !this.validate || this.password !== ''
    },
    isValid () {
      return this.validateEmail && this.validatePassword
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?2df43682